var map = {
	"./#03CEA4/paragraphEle.svg": "bf02",
	"./#3777FF/paragraphEle.svg": "942ac",
	"./#EE964B/paragraphEle.svg": "1533",
	"./#F754A2/paragraphEle.svg": "1cdd",
	"./#FF495C/paragraphEle.svg": "3785"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cea1";